<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Home':'होम'" routerLink="/">Home</a></li>
                <li class="breadcrumb-item"><a class="screen-reader" routerLinkActive="active-nemu" routerLink="/depot-details">Depot
                        Details</a></li>

            </ol>
        </nav>
    </div> 
    <!-- BREADCRUMB AREA - ENDS -->

    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">

                <div class="col-lg-12">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title d-flex justify-content-between">
                                        <h2 class="screen-reader" id="depot-table">Depot Details</h2>
                                    </div>
                                    <div class="description">
                                        <div class="tenders">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <!-- search section -->
                                                    <div class="searchpanel notific-frm">
                                                        <form [formGroup]="searchForm" (ngSubmit)="searchTender()">
                                                            <div class="row">
                                                                <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                                                    <div class="form-group font-adjust">
                                                                        <label class="mb-2 mt-2 screen-reader"> <b>Zone </b> </label>
                                                                        <select class="form-select screen-reader" name="zone"
                                                                            id="zone" #zone formControlName="zone"
                                                                            (change)="GetRegion(zone)">
                                                                            <option value="" selected>Select Zone
                                                                            </option>
                                                                            <option
                                                                                value="{{ item.int_Demographic_Id }}"
                                                                                *ngFor="let item of zoneList">{{
                                                                                item.vch_Demographic_Name }}</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                                                    <div class="form-group font-adjust">
                                                                        <label class="mb-2 mt-2 screen-reader"> <b> Region </b>
                                                                        </label>
                                                                        <select class="form-select screen-reader" name="region"
                                                                            id="region" formControlName="region" #region
                                                                            (change)="GetDepot(region)">
                                                                            <option value="" selected>Select Region
                                                                            </option>
                                                                            <option
                                                                                value="{{ item.int_Demographic_Id }}"
                                                                                *ngFor="let item of regionList">{{
                                                                                item.vch_Demographic_Name }}</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                                                    <div class="form-group font-adjust">
                                                                        <label class="mb-2 mt-2 screen-reader"> <b> Depot </b>
                                                                        </label>
                                                                        <select class="form-select screen-reader" name="depot"
                                                                            id="depot" formControlName="depot">
                                                                            <option value="" selected>Select Depot
                                                                            </option>
                                                                            <option
                                                                                value="{{ item.int_Demographic_Id }}"
                                                                                *ngFor="let item of depotList">{{
                                                                                item.vch_Demographic_Name }}</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-xl-3 col-md-12 col-sm-6 col-xs-12 d-flex align-items-end">
                                                                    <div class="d-flex align-items-center gap-3 mt-3">
                                                                        <button type="submit" [attr.title]="language=='English'?'Search':'खोजें'"
                                                                            class="btn btn-outline-success screen-reader"
                                                                            [disabled]="ifdisabled"
                                                                            [innerHTML]="btncontent">
                                                                        </button>
                                                                        <div *ngIf="RefreshBtn">
                                                                            <button type="button" [attr.title]="language=='English'?'Refresh':'रीफ़्रेश करें'"
                                                                                class="btn btn-outline-secondary py-0-2 screen-reader"
                                                                                (click)="RefreshPage()">
                                                                                <i class="bi bi-arrow-repeat fs-5" aria-hidden="true"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </form>
                                                    </div>
                                                    <!-- search section -->

                                                    <!-- tender section area -->


                                                    <div class="table-responsive font-adjust">
                                                        <table class="table table-hover" aria-describedby="depot-table"> <!-- Depot List Table -->
                                                            <thead class="thead-light">
                                                                <tr>
                                                                    <th class="screen-reader" scope="col">Zone</th>
                                                                    <th class="screen-reader" scope="col">Region</th>
                                                                    <th class="screen-reader" scope="col">Depot</th>
                                                                    <th class="screen-reader" scope="col">Depot Link</th>
                                                                    <th class="screen-reader" scope="col">Credential Details</th>
                                                                    <th class="screen-reader" scope="col">Additional Information</th>
                                                                    <th class="screen-reader" scope="col">Remarks</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let item of deoptList;">
                                                                    <td class="fw-bold screen-reader">{{
                                                                        jsonConvert(item,'INT_ZONE_ID')}}</td>
                                                                    <td class="screen-reader">{{ jsonConvert(item,'INT_REGION_ID')}}</td>
                                                                    <td class="screen-reader"> {{
                                                                        jsonConvert(item,'INT_DEPOT_ID')}}</td>
                                                                    <td class="screen-reader">
                                                                        <span *ngFor="let depotlink of item.depotLink;">
                                                                            <a href="{{ depotlink.linkName }}"
                                                                                target="_blank" [attr.title]="language=='English'?'Link':'लिंक'">{{
                                                                                depotlink.linkName }}</a>
                                                                        </span>
                                                                    </td>
                                                                    <td class="screen-reader">{{ item.credentialDetails }}</td>
                                                                    <td class="screen-reader">{{ item.additionalInformation }}</td>
                                                                    <td class="screen-reader">{{ item.remarks }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>



                                                    <!-- tender section area -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>